var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 37,
    viewBox: "0 0 28 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 0.625L7.30282 7.125H12.3255V21.75H15.674V7.125H20.6968L13.9998 0.625ZM24.0452 36.375H3.95434C3.06626 36.375 2.21456 36.0326 1.5866 35.4231C0.958637 34.8136 0.605851 33.987 0.605851 33.125V13.625C0.605851 12.763 0.958637 11.9364 1.5866 11.3269C2.21456 10.7174 3.06626 10.375 3.95434 10.375H8.97706V13.625H3.95434V33.125H24.0452V13.625H19.0225V10.375H24.0452C24.9333 10.375 25.785 10.7174 26.413 11.3269C27.0409 11.9364 27.3937 12.763 27.3937 13.625V33.125C27.3937 33.987 27.0409 34.8136 26.413 35.4231C25.785 36.0326 24.9333 36.375 24.0452 36.375Z",
    fill: "#00A2A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExport);
export default __webpack_public_path__ + "static/media/DownloadExport.6b1eb9881eac99f5ce9db5b38884f2b7.svg";
export { ForwardRef as ReactComponent };